import {
    DependencyList,
    Dispatch,
    SetStateAction,
    useCallback,
    useMemo,
    useRef,
    useState,
} from "react";
import { Func } from "./fnTypes";

/*
 */
export interface IUseStateEx {
    <S = undefined>(): [
        S | undefined,
        Dispatch<SetStateAction<S | undefined>>,
        () => S
    ];

    <S>(initialState: S | (() => S)): [S, Dispatch<SetStateAction<S>>, () => S];
}

export const useStateEx = (<S>(initialState) => {
    const [s, setS] = useState(initialState);
    const ref = useRef<S>();
    ref.current = s;
    return [s, setS, useCallback(() => ref.current, [])];
}) as IUseStateEx;

/*
 */
export const useMemoEx = <T>(
    factory: Func<T>,
    deps: DependencyList | undefined
): [T, Func<T>] => {
    const s = useMemo(factory, deps);
    const ref = useRef<T>();
    ref.current = s;
    return [s, useCallback(() => ref.current, [])];
};
